<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Department of Agriculture Clinic/ All Productivity Report
          </h2>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="columns">
            <div class="column">
              <b-field label="ປະເພດສິນຄ້າ">
                <Multiselect
                  placeholder="ເລືອກ"
                  v-model.trim="selectedTypeSearch"
                  label="NAME"
                  track-by="ID"
                  :options="typeList"
                  @input="productTypeSelectedSearch"
                >
                </Multiselect>
              </b-field>
            </div>
            <div class="column">
              <b-field label="ສິນຄ້າ">
                <Multiselect
                  placeholder="ເລືອກ"
                  v-model.trim="selectedProductSearch"
                  label="PRODUCTNAME"
                  track-by="PRODUCTID"
                  :options="productList"
                  @input="onSelectProduct"
                >
                </Multiselect>
              </b-field>
            </div>
            <div class="column">
              <b-field label="ເດືອນ">
                <Multiselect
                  placeholder="ເລືອກ"
                  v-model.trim="selectedMonth"
                  label="NAME"
                  track-by="ID"
                  :options="MonthList"
                  @input="getAllProductivity"
                >
                </Multiselect>
              </b-field>
            </div>
            <div class="column"></div>
            <div class="column"></div>
            <div class="column"></div>
          </div>
          <!-- <b-field style="margin-left: 20px" grouped> -->
          <!-- <b-field label="ຄົ້ນຫາສິນຄ້າ">
              <input
                type="text"
                class="input"
                v-model="search"
                v-on:keyup="productSearch"
              />
            </b-field> -->

          <!-- </b-field> -->

          <b-field label="ລາຍລະອຽດ">
            <table class="table is-fullwidth is-narrow is-small">
              <thead>
                <tr>
                  <th class="has-text-centered " width="5%">#</th>
                  <th class="has-text-left " width="25%">
                    ໂຊນກະສິກຳ
                  </th>
                  <th class="has-text-right " width="15%">
                    ຄວາມສາມາດຜະລິດ <br />(ກິໂລ/ຕາແມັດ)
                  </th>

                  <th class="has-text-right " width="15%">
                    ອັດຕາສ່ວນແນວພັນ <br />
                    (ກຼາມ/ຕາແມັດ)
                  </th>
                  <th class="has-text-right " width="15%">
                    ກະກຽມດິນ<br />(ຈຳນວນວັນ)
                  </th>
                  <th class="has-text-right " width="15%">
                    ກະກຽມແນວພັນ<br />(ຈຳນວນວັນ)
                  </th>
                  <th class="has-text-right " width="15%">
                    ເລີ່ມຜະລິດ<br />(ຈຳນວນວັນ)
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in activeproducts" :key="data.ID">
                  <td class="has-text-centered">{{ index + 1 }}</td>
                  <td class="has-text-left ">
                    {{ data.NAME }}
                  </td>
                  <td class="has-text-right ">
                    {{ data.P }}
                  </td>
                  <td class="has-text-right ">
                    {{ data.S }}
                  </td>
                  <td class="has-text-right ">
                    {{ data.R1 }}
                  </td>
                  <td class="has-text-right ">
                    {{ data.R2 }}
                  </td>
                  <td class="has-text-right ">
                    {{ data.R3 }}
                  </td>
                </tr>
              </tbody>
            </table>
          </b-field>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,
      selectedType: null,
      typeList: [],

      selectedFile: null,
      url: "uploadimage", // function name in api site
      photoname: null,
      photopath:
        process.env.NODE_ENV === "production"
          ? "https://agrilao.com/manager-main/api/uploads/products/"
          : "http://localhost/manager/api/uploads/products/",
      // photopath: process.env.NODE_ENV === "production" ? "http://51.222.85.54/agrilao-manager/api/uploads/products/" : "http://localhost/agrilao-manager/api/uploads/products/",
      photopreview: null,
      isSelectPhoto: false,

      selectedTypeSearch: null,
      search: null,
      selectedMonth: null,
      MonthList: [
        { ID: "01", NAME: "01" },
        { ID: "02", NAME: "02" },
        { ID: "03", NAME: "03" },
        { ID: "04", NAME: "04" },
        { ID: "05", NAME: "05" },
        { ID: "06", NAME: "06" },
        { ID: "07", NAME: "07" },
        { ID: "08", NAME: "08" },
        { ID: "09", NAME: "09" },
        { ID: "10", NAME: "10" },
        { ID: "11", NAME: "12" },
        { ID: "12", NAME: "12" },
      ],

      productList: [],
      selectedProductSearch: null,
      activeproducts: [],
    };
  },
  methods: {
    getAllProductivity() {
      var params = {
        productid: this.selectedProductSearch.PRODUCTID,
        month: this.selectedMonth.ID,
        username: this.username,
      };
      console.log("params: " + JSON.stringify(params));
      RestAPI.getClinicAllProductivity(params)
        .then((res) => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.activeproducts = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getProductTypes() {
      RestAPI.getClinicProductTypes("farming")
        .then((res) => {
          // console.log("getClinicProductTypes: " + JSON.stringify(res.data));
          this.typeList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    // productSearch() {
    //   this.selectedTypeSearch = null;
    //   // this.search = null;
    //   this.selectedHarvestSearch = null;

    //   if (this.search) {
    //     var params = {
    //       search: this.search,
    //     };
    //     RestAPI.searchClinicProducts(params)
    //       .then((res) => {
    //         this.activeproducts = res.data.activeproducts;
    //         this.inactiveproducts = res.data.inactiveproducts;
    //         // console.log("products: " + JSON.stringify(this.products));
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //         this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
    //       });
    //   } else {
    //     this.getProducts();
    //   }
    // },
    productTypeSelectedSearch() {
      this.selectedProductSearch = null;
      this.selectedMonth = null;
      if (this.selectedTypeSearch) {
        var params = {
          typeid: this.selectedTypeSearch.ID,
        };
        RestAPI.clinicProductTypeSelectedSearch(params)
          .then((res) => {
            this.productList = res.data;
            // console.log("res: " + JSON.stringify(res.data));
          })
          .catch((error) => {
            console.log(error);
            this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
          });
      }
    },
    onSelectProduct() {
      this.selectedMonth = null;
    },
    // onHarvestSearch() {
    //   if (this.selectedHarvestSearch) {
    //     var params = {
    //       typeid: this.selectedHarvestSearch.ID,
    //     };
    //     RestAPI.clinicProductHarvestSelectedSearch(params)
    //       .then((res) => {
    //         this.activeproducts = res.data;
    //         console.log("res: " + JSON.stringify(res.data));
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //         this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
    //       });
    //   } else {
    //     this.getProducts();
    //   }
    // },

    print() {
      window.print();
    },
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;

    // this.getAllProductivity();
    this.getProductTypes();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.preproductionstep {
  height: 35px;
}
</style>
